import { graphql, useStaticQuery } from "gatsby";
import { SiteOptions } from "../utils/optionsTypes";

export const useOptions: () => SiteOptions = () => {
  const data = useStaticQuery(graphql`
    query {
      wpOptions {
        data {
          currency
          currency_symbol
          comments_open
          country_default
          lang_cart {
            cart_page_title
            cart_shipping
            cart_subtotal
            cart_total
            chk_btn
            column_product
            continue_shop
            cp_applied
            cp_btn
            cp_plh
            discounts_amount_text
            express_chk
            qua
            remove_button_text
            remove_undo_text
            shipping_free
            tc_price
            tot
            undo_button_text
          }
          lang_cart_empty {
            empty_cart_text
            empty_cart_title
            return_button_text
          }
          lang_header {
            cart_button_text
            checkout_button_text
            search_button_text
            side_cart_subtotal_text
            search_input_placeholder
            side_cart_title
            view_cart_button_text
          }
          lang_misc {
            add_to_cart_mini
            breadcrumb_home_text
            by_newest
            by_oldest
            by_rating_high
            by_rating_low
            cat_sort_by_average_rating
            cat_sort_by_latest
            cat_sort_by_popularity
            cat_sort_by_price_hight_to_low
            cat_sort_by_price_low_to_high
            search_not_found
            sort_by_phrase
          }
          thank_you_page {
            no_email_text
            order_details_text
            th_text
            th_title
          }
          address_column_title
          footer_comapny_address
        }
      }
    }
  `);

  return data;
};
